module.exports = __webpack_public_path__ + "img/grade3.4aba6eff.png";